<div class="titel">{{data.titel}}</div>
<div class="ondertitel">{{data.ondertitel}}</div>
